import { render, staticRenderFns } from "./bookConfig.vue?vue&type=template&id=6c6c0914&"
import script from "./bookConfig.vue?vue&type=script&lang=js&"
export * from "./bookConfig.vue?vue&type=script&lang=js&"
import style0 from "./bookConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports